import React from 'react';
import { Handle, Position } from 'reactflow';
import NodeSymbolSelect from './NodeSymbolSelect';

const actionOptions = [
  { value: 'buy', label: 'Buy (open long)' },
  { value: 'sell', label: 'Sell (close long)' },
  { value: 'short', label: 'Short (open short)' },
  { value: 'cover', label: 'Cover (close short)' },
  { value: 'close', label: 'Close Position (either direction)' },
];

const sizeTypeOptions = [
  { value: 'pct_cash', label: 'Cash %' },
  { value: 'risk_pct', label: 'Risk %' },
];

const SHORT_SIDE_COLOR = '#f85149';
const LONG_SIDE_COLOR = '#26a641';

export default function ActionNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  const action = data.action || 'buy';
  const color = action === 'short' || action === 'cover' ? SHORT_SIDE_COLOR : LONG_SIDE_COLOR;
  const sizeType = data.size_type || 'pct_cash';
  const isRisk = sizeType === 'risk_pct';

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: `2px solid ${color}`,
      background: 'var(--card)',
      minWidth: 180,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <Handle type="target" position={Position.Left} id="input" style={{ top: '30%', background: color }} />
      <Handle type="target" position={Position.Left} id="stop_loss" style={{ top: '55%', background: '#f85149' }} title="Stop Loss" />
      <Handle type="target" position={Position.Left} id="take_profit" style={{ top: '80%', background: '#26a641' }} title="Take Profit" />
      <div style={{ fontWeight: 700, marginBottom: 8, color }}>
        🎯 Action
      </div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />
      <select
        value={data.action || 'buy'}
        onChange={(e) => onChange('action', e.target.value)}
        style={{ width: '100%', marginBottom: 6, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
      >
        {actionOptions.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
        <select
          value={sizeType}
          onChange={(e) => onChange('size_type', e.target.value)}
          style={{ flex: 1, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontSize: 11 }}
          title="Only applies to entry actions (Buy/Short)"
        >
          {sizeTypeOptions.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
        <input
          type="number"
          value={data.size_pct ?? 100}
          onChange={(e) => onChange('size_pct', parseFloat(e.target.value) || (isRisk ? 1 : 100))}
          style={{ width: 60, padding: 2, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
          min={0.1}
          max={100}
          step={isRisk ? 0.5 : 1}
        />
      </div>
      {isRisk && (
        <div style={{ marginTop: 6, fontSize: 10, color: 'var(--muted)', lineHeight: 1.4 }}>
          Risks {data.size_pct ?? 1}% of account equity if the wired Stop Loss is hit. Requires a Stop Loss
          connected to this node's stop-loss input.
        </div>
      )}
    </div>
  );
}
